<template>
    <div
        class="nch--header-container d-flex justify-content-center text-header"
        :style="headerType === 1 ? backgroundStyle : {backgroundColor: color.primary}"
    >
        <div v-if="headerType !== 0" class="align-self-center nch--content-description">
            <h1 :style="{color: color.secondary}">{{header.translation.name}}</h1>
            <h4 v-if="header.type === 4" :style="{color: color.secondary}">{{planRecurrence}}</h4>
        </div>
        <div v-if="headerType === 0">
            <img
                class="rounded img-fluid img-center mt-5 banner "
                :src="image(header.layout.dashboard_img)"
                alt="Imagem do Plano"
            />
            <h1 class="my-5" :style="{color: color.secondary}">{{header.translation.name}}</h1>
        </div>
        <div
            class="nch--action-button"
            :style="[$bgColor(color.button || color.primary), { color: color.secondary }]"
        >
            <p @click="planActionType.event" :style="{ color: color.secondary }">{{$t(planActionType.label)}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlanDetailsHeader',

    props: {
        header: {
            type: Object,
            required: true,
        },
        continue: {
            type: [String, Boolean],
        },
        recurrenceDays: {
            type: Number,
            required: true,
        },
    },

    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        user() {
            return this.$store.getters.USER;
        },
        headerType() {
            if (
                !Object.prototype.hasOwnProperty.call(this.header.layout, 'dashboard_img') ||
                this.header.layout.dashboard_img === null
            ) { return 2; }
            return this.header.layout.dashboard_img_option;
        },
        backgroundStyle() {
            return {
                backgroundImage: `url(${this.image(
                    this.header.layout.dashboard_img,
                )})`,
                backgroundColor: this.color.primary,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            };
        },

        planRecurrence() {
            switch (this.header.days) {
            case 30:
                return this.$t('cart.recurrence.monthly');
            case 60:
                return this.$t('cart.recurrence.bimonthly');
            case 90:
                return this.$t('cart.recurrence.quarterly');
            case 180:
                return this.$t('cart.recurrence.semiannual');
            case 360:
                return this.$t('cart.recurrence.yearly');
            default:
                return (
                    `${this.$t('cart.recurrence.custom')
                    } ${
                        this.recurrenceDays
                    } ${
                        this.$t('cart.recurrence.days')}`
                );
            }
        },

        planActionType() {
            if (!this.continue) {
                if (this.header.type === 1) {
                    return {
                        event: () => this.subscribe(),
                        label: 'cart.subscribe',
                    };
                }
                if (this.header.type === 2) {
                    return {
                        event: () => this.goPublicPlan(),
                        label: 'cart.access_plan',
                    };
                }
                if (this.header.type === 3 || this.header.type === 4) {
                    return {
                        event: () => this.addCart(),
                        label: 'common.buy',
                    };
                }
            } else {
                return {
                    event: () => {
                        location.href = this.continue;
                    },
                    label: 'common.continue',
                };
            }
            return { event: () => {}, label: '' };
        },
    },

    methods: {
        goPublicPlan() {
            this.$loading.show();
            // Verifica se o plano tem captura de leads ativa
            if (this.header.link_leads) {
                // Redireciona para a página de captura de leads
                const leadsUrl = `/app/public/plan/${this.header.id}/leads`;
                window.location.href = leadsUrl;
            } else {
                // Acesso direto ao plano - obter URL assinada
                window.axios.get(`/api/app/public/plan/${this.header.id}/signed-url`)
                    .then((urlResponse) => {
                        if (urlResponse.data && urlResponse.data.url) {
                            window.location.href = urlResponse.data.url;
                        } else {
                            console.error('No signed URL returned');
                            window.location.href = `/app/public/plan/${this.header.id}`;
                        }
                    })
                    .catch((error) => {
                        console.error('Error getting signed URL:', error);
                        window.location.href = `/app/public/plan/${this.header.id}`;
                    });
            }
        },
        subscribe() {
            if (!this.user.id || this.user.public) {
                localStorage.setItem('plan', this.header.translation.name);
                localStorage.setItem('plan-id', this.header.id);
                location.href = '/register';
            } else this.addCart();
        },

        image(src) {
            if (src.urls && src.urls.original) {
                return src.urls.original;
            }
            if (src.host) {
                return `/storage/${src.host}/original/${src.original_file}`;
            } return '';
        },
        addCart() {
            this.$emit('add');
        },
    },
};
</script>

<style scoped>
.text-header {
    min-height: 40vh;
}
.banner {
    width: 70%;
    background-image: url();
}

@media only screen and (min-width: 1080px) {
    .banner {
        width: 50%;
    }
}
@media only screen and (max-width: 600px) {
    .banner {
        width: 90%;
    }
}
</style>
